module.exports = __webpack_public_path__ + "img/8.40e7f45c.png";